<template>
  <div class="result-page">
    <div class="nav-bar">
      <ul class="nav-item">
        <!-- <li>
          <a href="/">首页</a>
        </li>
        <li>
          <a href>信息公告</a>
        </li>
        <li style="background-color: #810f0e;">
          <a href>资质申报</a>
        </li>
        <li>
          <a href>用户反馈</a>
        </li>
        <li>
          <a href>使用帮助</a>
        </li>-->
        <li>
          <a :href="index_url" target="_blank">访问官网</a>
        </li>
        <li style="background-color: #810f0e;">
          <a :href="login_url" target="_blank">注册 登录</a>
        </li>
      </ul>
    </div>

    <div class="outer-header">
      <div class="i-header">
        <div class="header-left">
          <div class="logo">
            <img style="display:inline; width: 68px; height: 68px;" src="../assets/search/logo.png" />
          </div>
          <div class="header-title">
            <p class="main-title">中国安全技术防范工程行业网</p>
            <p class="sub-title">China Safety Engineering Association</p>
          </div>
        </div>
        <div class="header-right">
          <div class="contents">
            <h1 style="font-size: 16px; color: #666">资质查询系统</h1>
            <el-input placeholder="请输入企业名称、统一社会信用代码" v-model="name" class="input-with-search">
              <el-button
                style="background-color: #B72215; color: #fff;width:68px;height: 42px;border-radius:1px; margin-bottom: -10px;"
                slot="append"
                @click="searchResult"
                icon="el-icon-search"
              ></el-button>
            </el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="company-info">
      <div class="left-info" v-if="haveResult">
        <h1 style="font-size: 24px; color: #333;margin-top:0;">{{ corporateInfo.corporateName }}</h1>
        <div class="specify">
          <div class="specify-item">统一社会信用代码：{{ corporateInfo.socialCreditNo }}</div>
          <div class="specify-item">法定代表人：{{ corporateInfo.legalName }}</div>
          <div class="specify-item">
            成立日期：{{
            corporateInfo.regDate ? corporateInfo.regDate.split(" ")[0] : ""
            }}
          </div>
        </div>
        <span class="share" @click="toshare">信息分享</span>
      </div>
      <div class="left-info" v-if="!haveResult">
        <h3 style="color: #C00; font-weight: bold; text-align: center">未查询到结果，请确认输入信息正确。</h3>
      </div>
    </div>

    <div class="more-info" v-if="haveResult">
      <div class="corporate-credits">
        <div class="certifcate-info">证书信息</div>
        <div v-for="credits in corporateCredits" :key="credits.creditName">
          <el-row :gutter="20">
            <el-col>证书名称：{{ credits.creditName }}</el-col>
          </el-row>
          <el-row :gutter="24" style="margin-top:5px;">
            <el-col :xs="24" :sm="4">证书等级：{{ credits.creditLevel }}</el-col>
            <el-col :xs="24" :sm="6">证书编号：{{ credits.creditCode }}</el-col>
            <el-col :xs="24" :sm="6">有效期限：{{ credits.validDate.split(" ")[0] }}</el-col>
            <el-col :xs="24" :sm="6">证书类别：{{ credits.creditType }}</el-col>
          </el-row>
          <el-divider></el-divider>
        </div>
      </div>

      <div class="people-credits" v-if="haveResult">
        <div class="people-info">人员资质</div>
        <el-table :data="personCredits" size="small" border :row-class-name="tableRowClassName">
          <el-table-column type="index" label="序号" width="50" align="center" />
          <el-table-column prop="userName" label="姓名" align="center" />
          <el-table-column prop="creditName" label="证书名称" align="center" />
          <el-table-column prop="creditLevel" label="证书等级" align="center" />
          <el-table-column prop="creditCode" label="登记编号" align="center" />
          <el-table-column prop="creditType" label="证书类别" align="center" width="180" />
          <el-table-column prop="issueDateTxt" label="发证日期" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :visible.sync="qrcodedialog" title="微信扫一扫" :center="true" width="400px" @close="closedialog">
      <div id="qrcode" ref="qrcodeurl"></div>
    </el-dialog>

    <div class="footer">
      <div>Copyright © 2018-2020 中国安全技术防范工程行业网 版权所有</div>
      <div>客服信箱：service@chinasea.org</div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import QRCode from 'qrcodejs2'
export default {
  name: "resultPage",
  data() {
    return {
      name: "",
      corporateInfo: {},
      personCredits: [],
      corporateCredits: [],
      haveResult: true,
      index_url: process.env.VUE_APP_INDEX_URL,
      login_url: process.env.VUE_APP_LOGIN_URL,
      qrcodedialog: false
    };
  },
  methods: {
    tableRowClassName({ row }) {
      if (row.isExpire) {
        return "expire-row";
      } else {
        return "normal-row";
      }
    },
    searchResult() {
      axios({
        method: "get",
        url: process.env.VUE_APP_BASE_URL + "/auth/query-corporateCredit",
        params: {
          searchText: this.name
        }
      })
        .then(response => {
          if (!response.data.data) {
            this.haveResult = false;
            return;
          } else {
            this.haveResult = true;
          }
          this.corporateInfo = Object.assign(
            {},
            response.data.data.corporateInfo
          );
          this.corporateCredits.splice(0);
          if (response.data.data.corporateCredits) {
            response.data.data.corporateCredits.forEach(item => {
              this.corporateCredits.push(item);
            });
          }

          this.personCredits.splice(0);
          if (response.data.data.personCredits) {
            response.data.data.personCredits.forEach(item => {
              this.personCredits.push(item);
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    toshare() {
      this.qrcodedialog = true
      this.$nextTick(function () {
        this.qrcode();
      })
    },
    closedialog() {
      this.$refs.qrcodeurl.innerHTML = ''
      this.qrcodedialog = false;

    },
    qrcode() {
      new QRCode('qrcode', {
        width: 132,
        height: 132,
        text: window.location.href,
        colorDark: "#000",
        colorLight: "#fff"
      })
    }
  },
  mounted() {
    this.name = this.$route.query.name
    axios({
      method: "get",
      url: process.env.VUE_APP_BASE_URL + "/auth/query-corporateCredit",
      params: {
        searchText: this.$route.query.name
      }
    }).then(response => {
      if (!response.data.data) {
        this.haveResult = false;
        return;
      } else {
        this.haveResult = true;
      }
      this.corporateInfo = Object.assign({}, response.data.data.corporateInfo);
      this.corporateCredits.splice(0);
      if (response.data.data.corporateCredits) {
        response.data.data.corporateCredits.forEach(item => {
          this.corporateCredits.push(item);
        });
      }

      this.personCredits.splice(0);
      if (response.data.data.personCredits) {
        response.data.data.personCredits.forEach(item => {
          this.personCredits.push(item);
        });
      }
    });
  }
};
</script>

<style scoped>
.result-page {
  background-color: #f5f5f5;
}

.nav-bar {
  width: 100%;
  height: 52px;
  background-color: #a82b2a;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-item {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  padding: 0;
}

.nav-item > li {
  color: #fff;
  line-height: 20px;
  list-style-type: none;
  /* margin: 0 40px; */
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 12px;
  padding-left: 40px;
  padding-right: 40px;
}

a {
  text-decoration: none;
  color: #fff;
}

.nav-item > a:hover {
  background-color: #810f0e;
}

.outer-header {
  width: 100%;
  background-color: #fff;
}

.i-header {
  background-color: #fff;
  width: 1200px;
  margin: 0 auto;
  /* margin-bottom: 5px; */
  padding-bottom: 15px;
  display: flex;
  justify-content: flex-around;
}

.header-left {
  flex: 6;
}

.header-right {
  flex: 5;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.contents {
  width: 90%;
}

.contents >>> .el-input__inner {
  border-color: #a82b2a;
}

.logo {
  display: inline-block;
  height: 68px;
  width: 68px;
}

.header-title {
  display: inline-block;
  height: 66px;
  width: 66px;
}

.main-title {
  width: 458px;
  height: 32px;
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(168, 43, 42, 1);
  margin-bottom: 15px;
  margin-left: 5px;
  margin-top: 15px;
}

.sub-title {
  width: 389px;
  height: 23px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(77, 77, 77, 1);
  margin-left: 5px;
}

.company-info {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  background-color: #fff;
}

.left-info {
  display: flex;
  flex-flow: column;
  padding: 30px;
  position: relative;
}
.share {
  display: inline-block;
  width: 140px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  color: #fff;
  position: absolute;
  top: 46px;
  right: 40px;
  cursor: pointer;
  padding-left: 20px;
  box-sizing: border-box;
  background: #eb6c65 url("../assets/share.png") no-repeat 25px 10px;
}

.specify {
  width: 80%;
  display: flex;
  justify-content: flex-between;
}

.specify-item {
  margin-right: 50px;
  font-size: 14px;
  color: #555;
}

.more-info {
  width: 1200px;
  margin: 15px auto;
  background-color: #fff;
  padding-bottom: 20px;
}

.corporate-credits {
  margin: 0 auto;
  margin-top: 15px;
  background-color: #fff;
  padding: 20px 25px;
  box-sizing: border-box;
  color: #333;
  font-size: 14px;
  line-height: 26px;
}

.people-credits {
  margin: auto;
  margin-top: 15px;
  background-color: #fff;
  padding: 20px 25px;
  color: #333;
}

.certifcate-info {
  line-height: 18px;
  border-left: 6px solid #a82b2a;
  padding-left: 10px;
  margin-bottom: 20px;
  font-size: 16px;
}

.people-info {
  line-height: 18px;
  border-left: 6px solid #a82b2a;
  padding-left: 10px;
  margin-bottom: 20px;
}

.footer {
  margin-top: 80px;
  border-top: 1px solid #e6e6e6;
  font-size: 14px;
  color: #999;
  background-color: #fff;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
}

.el-table .expire-row {
  color: #ccc;
}
.el-divider--horizontal {
  margin: 16px 0;
}
#qrcode{
  width: 132px;
  margin: 0 auto;
}
@media screen and (max-width: 768px) {
  .nav-bar,
  .header-right {
    display: none;
  }
  .i-header {
    width: 100%;
    display: inline-block;
    padding: 10px 0;
  }
  .main-title,
  .sub-title {
    width: 100%;
    font-size: 16px;
    margin: 6px;
    height: 28px;
  }
  .logo {
    vertical-align: top;
  }
  .header-title {
    width: 80%;
  }
  .contents {
    padding: 5px;
  }
  .left-info {
    padding: 20px 10px;
  }

  .specify {
    width: 100%;
    display: block;
  }
  .people-credits >>> .el-table__body-wrapper::-webkit-scrollbar {
    height: 6px;
  }
  .people-credits >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ccc;
    background-clip: padding-box;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    min-height: 10px;
  }
  .nav-item ,.more-info ,.i-header, .company-info{
    width: 90%;
  }
  .share{
    display: none;
  }
}
</style>
<style>
.el-table th {
  background: #f7e8e8;
  color: #333;
}
.el-table td {
  background: #f9f9f9;
  color: #1a1a1a;
}
</style>